import "./App.css";
import { Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Suspense, lazy, useEffect, useState } from "react";
import "./App.css";
import { ThreeDots } from "react-loader-spinner";
import { BlockUI } from "primereact/blockui";
import { useDispatch } from "react-redux";
import SffLanguage from "./components/common/Languages/SffLanguage";
import LoginService from "./api/services/login.service";
import RouteDefinitions from "./RouteDefinitions";
import AccessDeniedPage from "./pages/Login/AccessDenied";
import Noaccess from "./pages/Login/NoAccess";
import Login from "./pages/Login/Login";
import ErrorBoundary from "./components/common/ErrorBoundary/ErrorBoundary";
import { useSelector } from "react-redux";
import { RootState } from "./states/store";
import useFetchCountryUseraccess from "./hooks/useFetchCountryUseraccess";
import FrameBuster from "./FrameBuster";
// import {FHButton} from "fh-visual-library";
import { useCookies } from "react-cookie";

const Navbar = lazy(() => import("./components/common/NavBar/Navbar"));
//import Navbar from "./Components/Common/NavBar/Navbar";

function App() {
  const loginReduxData = useSelector((state: RootState) => state.rootReducer.LoginReducer);
   const [cookies, setCookie, removeCookie] = useCookies([
      "codeVerifier",
      "refreshToken",
      "accessToken",
      "userId",
      "expiry",
      "tokenType",
      "userName"
    ]);
  const location = useLocation();
  const pathName = location.pathname;
  //const navigate = useNavigate();
  const action = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [invalidUser, setinvalidUser] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  const { changeLanguage } = SffLanguage();
  const [params] = useSearchParams();
  const [showMenu, setShowMenu] = useState(false);
  const [roleId, setRoleId] = useState(null);  
  const showMenuNavbar = (value: any) => {
    setShowMenu(value);
  };
  const hideNavbar = ["/login"];
  const {countryData, userAccessData} = useFetchCountryUseraccess();
  let timeoutId: ReturnType<typeof setTimeout>;

    useEffect(() => {
      if(countryData.data && countryData.data.length > 0) {
        action({
          type: "updateLoginDetails",
          payload: {
            name: "countriesDropDown",
            value: countryData.data,
          },
        });
        if(Object.keys(loginReduxData.selectedCounty).length === 0) {
          action({
            type: "updateLoginDetails",
            payload: {
              name: "selectedCounty",
              value: countryData.data[0],
            },
          });
          action({
            type: "updateLoginDetails",
            payload: {
              name: "initialCountry",
              value: countryData.data[0],
            },
          });
        }
        
      }
      
      if(userAccessData.data && userAccessData.data.length > 0) {
        action({
          type: "setUserAccess",
          payload: userAccessData.data,
        });
      }      
    }, [countryData.data,userAccessData.data]);

  const checkUser = async () => {    
    try {
      setLoader(true);
      let response:any = await LoginService.userDetails();
      if (!response.isAxiosError) {
        if (response.data.success) {
          action({
            type: "updateLoginDetails",
            payload: {
              name: "roleId",
              value: response.data.data[0].AssignedRoles[0].Role.Name
            }
          });
          // setRoleId(response.data.data[0].AssignedRoles[0].Role.Name);
          action({
            type: "updateLoginDetails",
            payload: {
              name: "loggedUserDetails",
              value: response.data.data,
            },
          });
          action({
            type: "updateLoginDetails",
            payload: {
              name: "dummySelectedCountry",
              value: response.data.data[0].AssignedRoles[0].AssignedAreas[0],
            },
          });
          //navigate("/", { replace: true });
          // getCountryDetails();
        }
      } else {
        if (response.response?.status === 401) {
          setinvalidUser(true);
        } else if (response.code == "ERR_NETWORK") {
          setNetworkError(true);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== "development") {
      //checkUser();

      if (pathName !== "/accessdenied") {
        if (pathName === "/login" && params.get("code") !== null) return;
        let refreshToken = cookies.refreshToken || "";
        if (refreshToken && refreshToken != "undefined") {
          // this should trigger if the token is expired or not
          checkUser();
          action({
            type: "updateLoginDetails",
            payload: {
              name: "tokenDetails",
              value: {
                accessToken:cookies.accessToken,
                refreshToken:cookies.refreshToken,
                userId:cookies.userId,
                expiry:cookies.expiry,
                tokenType:cookies.tokenType,
                userName:cookies.userName,
              },
            },
          });
        } else {
          navigate("/login", { replace: true });
        }
      }
    } else {
      hideNavbar.includes(pathName);
    }
  }, []);
  useEffect(() => {
    setRoleId(loginReduxData.roleId);
  }, [loginReduxData?.roleId]);

  //  RefreshToken code start

  const getRefreshToken = (refreshToken: string) => {

    const cookieOptions = {
      httpOnly: false,
      secure: false,
      sameSite: false,
    };

    LoginService.refreshToken(refreshToken || "")
      .then((res) => {

        if(res?.data){
          const tokenDetails = {
            ...res.data,
            userName: cookies.userName
          };
          action({
          type: "updateLoginDetails",
          payload: {
            name: "tokenDetails",
            value: tokenDetails
          }
        });

        setCookie("userName", cookies.userName);
          setCookie("userId", cookies.userId);
          setCookie("tokenType", cookies.tokenType);
          setCookie("accessToken", res.data?.accessToken, cookieOptions);
          setCookie("refreshToken", res.data?.refreshToken, cookieOptions);
          setCookie("expiry", res.data?.expiry, cookieOptions);
          scheduleTokenRefresh(); // Schedule next refresh
        }
        
      })
      .catch((error) => {
        sessionStorage.clear();
        localStorage.clear();
        navigate("/login", { replace: true });
      })
      .finally(() => {
        setLoader(false);
      });

  };

  const scheduleTokenRefresh = () => {
    let refreshToken = cookies?.refreshToken || "";
    if (refreshToken && cookies?.expiry) {
      timeoutId = setTimeout(async () => {
        await getRefreshToken(refreshToken);
      }, (cookies?.expiry - 300) * 1000); 
    }
  };

  useEffect(() => {
    let refreshToken = cookies?.refreshToken || "";

    if (refreshToken) {
      getRefreshToken(refreshToken);
    }

    return () => {
      clearTimeout(timeoutId); // Cleanup on unmount
    };
  }, []);

  //  RefreshToken code end
  return (
    <>
    <FrameBuster />
    <BlockUI
      blocked={loader}
      fullScreen
      template={<ThreeDots height="80" width="80" color="#40BBBD" />}
    >
      <div className="App">
        
        <div
          className="main-container"
        >
       <Routes>
              <Route path="/accessdenied" element={<AccessDeniedPage />} />
              <Route path="/no-access" element={<Noaccess />} />{" "}
              <Route path="/login" element={<Login />} />
            </Routes>
          <ErrorBoundary>
            {roleId ? <RouteDefinitions roleId={roleId} /> : ""}
          </ErrorBoundary>
        
        </div>
      </div>
      </BlockUI>
      </>
  );
}

export default App;
